<template>
  <div class="wl-clinic-create-panel">
    <validation-observer ref="formObserver" #default="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(submit)">
        <b-row>
          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="First Name" rules="required">
              <b-form-group label="First name *" label-class="font-weight-bold">
                <b-form-input v-model="form.name" :state="fieldState(ctx)" trim />
                <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="Last Name" rules="required">
              <b-form-group label="Last name *" label-class="font-weight-bold">
                <b-form-input v-model="form.lastname" :state="fieldState(ctx)" trim />
                <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider v-if="!isInsurance" name="Email" rules="required|email" v-slot="{ errors }">
              <b-form-group label="Email *" label-class="font-weight-bold">
                <b-form-input v-model="form.email" :state="errors.length ? false : null" />
                <b-form-invalid-feedback>Email is required and must be valid.</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider v-else #default="ctx" name="Phone" rules="required|max:14">
              <b-form-group label="Phone *" label-class="font-weight-bold">
                <b-form-input v-model="formatPhone" :state="fieldState(ctx)" />
                <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col v-if="!isInsurance" cols="12" md="4">
            <validation-provider #default="ctx" name="Phone" rules="required|max:14">
              <b-form-group label="Phone *" label-class="font-weight-bold">
                <b-form-input v-model="formatPhone" :state="fieldState(ctx)" />
                <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="Gender" rules="required">
              <b-form-group label="Gender *" label-class="font-weight-bold">
                <treeselect
                  v-model="form.gender"
                  :options="genderOptions"
                  :normalizer="normalizer"
                  placeholder="Select gender" />
                <b-form-invalid-feedback v-if="ctx.touched && !form.gender">
                  This field is required
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="DOB" rules="required">
              <b-form-group label="Date of birth *" label-class="font-weight-bold">
                <flat-pickr
                  v-model="form.date_birth"
                  :config="dateConfig"
                  class="form-control"
                  placeholder="MM-DD-YYYY" />
                <b-form-invalid-feedback v-if="ctx.touched && !form.date_birth">
                  {{ ctx.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="Type visit" rules="required">
              <b-form-group label="Type visit *" label-class="font-weight-bold">
                <treeselect
                  v-model="form.type_visits_id"
                  :options="visitTypeOptions"
                  :normalizer="normalizer"
                  placeholder="Select type visit" />
                <b-form-invalid-feedback v-if="ctx.touched && !form.type_visits_id">
                  {{ ctx.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="Visit Reason" rules="required">
              <b-form-group label="Visit reason *" label-class="font-weight-bold">
                <treeselect
                  v-model="form.reason_visit"
                  :options="visitReasonOptions"
                  :normalizer="normalizer"
                  :searchable="true"
                  placeholder="Select visit reason" />
                <b-form-invalid-feedback v-if="ctx.touched && !form.reason_visit">
                  {{ ctx.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col v-if="showOtherReason" cols="12" md="4">
            <validation-provider #default="ctx" name="Other Reason" rules="required">
              <b-form-group label="Specify reason *" label-class="font-weight-bold">
                <b-form-input v-model="form.reason_visit_other" :state="fieldState(ctx)" />
                <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <template v-if="isInsurance">
            <b-col cols="12" md="4">
              <validation-provider #default="ctx" name="Insurance Agent" rules="required">
                <b-form-group label="Insurance agent *" label-class="font-weight-bold">
                  <treeselect
                    v-model="form.agent_insurance_id"
                    :options="agentOptions"
                    :normalizer="normalizer"
                    placeholder="Select agent" />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="4">
              <validation-provider #default="ctx" name="Name Insurance" rules="required">
                <b-form-group label="Insurance name *" label-class="font-weight-bold">
                  <treeselect
                    v-model="form.nameInsuranceId"
                    :options="insuranceNameOptions"
                    :normalizer="normalizer"
                    placeholder="Select insurance" />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="4">
              <validation-provider #default="ctx" name="Member ID" rules="required|max:255">
                <b-form-group label="Member ID *" label-class="font-weight-bold">
                  <b-form-input v-model="form.member_id" :state="fieldState(ctx)" trim />
                  <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="ctx" name="Copay" rules="required|min_value:0|numeric">
                <b-form-group label="Copay *" label-class="font-weight-bold">
                  <b-form-input v-model="form.copay" type="number" min="0" :state="fieldState(ctx)" />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="ctx" name="Co Insurance" rules="required|min_value:0|numeric">
                <b-form-group label="Co-insurance *" label-class="font-weight-bold">
                  <b-form-input v-model="form.co_insurance" type="number" min="0" :state="fieldState(ctx)" />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="ctx" name="Deducible" rules="required|min_value:0|numeric">
                <b-form-group label="Deductible *" label-class="font-weight-bold">
                  <b-form-input v-model="form.deducible" type="number" min="0" :state="fieldState(ctx)" />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="ctx" name="Out Pocket" rules="required|min_value:0|numeric">
                <b-form-group label="Out of pocket *" label-class="font-weight-bold">
                  <b-form-input v-model="form.out_pocket" type="number" min="0" :state="fieldState(ctx)" />
                </b-form-group>
              </validation-provider>
            </b-col>
          </template>

          <b-col v-if="showReference" cols="12" md="4">
            <validation-provider #default="ctx" name="Reference" rules="required">
              <b-form-group label="Reference *" label-class="font-weight-bold">
                <treeselect
                  v-model="form.user_references_id"
                  :options="referenceOptions"
                  :normalizer="normalizer"
                  placeholder="Select reference" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider name="Address" rules="required" v-slot="{ errors }">
              <b-form-group label="Address *" label-class="font-weight-bold">
                <b-form-input v-model="form.address" :state="errors.length ? false : null" />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="City" rules="required">
              <b-form-group label="City *" label-class="font-weight-bold" class="city-autocomplete-wrap">
                <small class="d-block text-muted mb-1">Type and select from the list.</small>
                <b-form-input
                  v-model="cityName"
                  :state="form.cities_id ? true : (cityName ? false : null)"
                  placeholder="Search city"
                  @input="searchCities"
                  @focus="cityName && searchCities()" />
                <div v-if="cityOptions.length" class="city-options-list">
                  <div
                    v-for="opt in cityOptions"
                    :key="opt.value"
                    class="city-option-item"
                    @mousedown.prevent="selectCity(opt)">
                    {{ opt.text }}
                  </div>
                </div>
                <b-form-invalid-feedback v-if="cityName && !form.cities_id">
                  Select a city from the list.
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider #default="ctx" name="Zip Code" rules="required">
              <b-form-group label="Zip code *" label-class="font-weight-bold">
                <b-form-input v-model="form.zip_codes_id" type="number" :state="fieldState(ctx)" />
                <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <div class="d-flex align-items-center mt-2">
          <b-button variant="primary" type="submit" :disabled="saving">
            <span v-if="!saving"><i class="fas fa-save mr-1"></i> Create clinic patient</span>
            <span v-else><SpinnerLoading /></span>
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BRow,
  BCol,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Treeselect from '@riophae/vue-treeselect'
import flatPickr from 'vue-flatpickr-component'
import SpinnerLoading from '@/components/SpinnerLoading'
import { required, email, max, minValue, numeric } from '@validations'
import { notificationCheck } from '@/mixins/NotificationSetup'
import normalVisitsApi from '@/core/services/api/admin/consults/visits'
import insuranceVisitsApi from '@/core/services/apiInsurance/admin/consults/visits'
import insuranceNameApi from '@/core/services/apiInsurance/admin/consults/insuranceName'
import {
  isInsuranceContext,
  getClinicPatientApi,
  getClinicCitiesApi,
  extractCreatedPatientId,
} from '../clinicPatientBridge'

const REFERENCE_VISIT_TYPES = [2, 3, 13, 14]

function defaultForm(isInsurance) {
  return {
    name: '',
    lastname: '',
    email: '',
    phone: '',
    gender: null,
    type_visits_id: null,
    reason_visit: 'Semaglutide',
    reason_visit_other: '',
    address: '',
    cities_id: null,
    zip_codes_id: null,
    date_birth: '',
    user_references_id: null,
    ...(isInsurance
      ? {
          agent_insurance_id: null,
          nameInsuranceId: null,
          member_id: '',
          copay: '',
          co_insurance: '',
          deducible: '',
          out_pocket: '',
        }
      : {}),
  }
}

export default {
  name: 'ClinicPatientCreatePanel',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    Treeselect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    SpinnerLoading,
  },
  props: {
    programContext: { type: String, default: 'normal' },
  },
  data() {
    return {
      required,
      email,
      max,
      minValue,
      numeric,
      form: defaultForm(isInsuranceContext(this.programContext)),
      saving: false,
      visitTypeOptions: [],
      referenceOptions: [],
      agentOptions: [],
      insuranceNameOptions: [],
      cityName: '',
      cityOptions: [],
      citySearchTimer: null,
      genderOptions: [
        { id: 'male', name: 'Male' },
        { id: 'female', name: 'Female' },
      ],
      visitReasonOptions: [
        { id: 'Semaglutide', name: 'Semaglutide' },
        { id: 'Follow Up', name: 'Follow Up' },
        { id: 'Consultation', name: 'Consultation' },
        { id: 'General Check', name: 'General Check' },
        { id: 'Other', name: 'Other' },
      ],
      dateConfig: { dateFormat: 'm-d-Y', allowInput: true, static: true },
      normalizer(node) {
        return { id: node.id, label: node.name }
      },
    }
  },
  computed: {
    isInsurance() {
      return isInsuranceContext(this.programContext)
    },
    showOtherReason() {
      return this.form.reason_visit === 'Other'
    },
    showReference() {
      return REFERENCE_VISIT_TYPES.includes(this.form.type_visits_id)
    },
    formatPhone: {
      get() {
        const phone = String(this.form.phone || '')
        return phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
      },
      set(val) {
        this.form.phone = val
      },
    },
  },
  watch: {
    programContext() {
      this.resetForm()
      this.loadOptions()
    },
    'form.reason_visit'(val) {
      if (val !== 'Other') this.form.reason_visit_other = ''
    },
  },
  mounted() {
    this.loadOptions()
  },
  methods: {
    fieldState(ctx) {
      if (ctx.errors?.length) return false
      if (ctx.touched && !ctx.valid) return false
      return null
    },
    resetForm() {
      this.form = defaultForm(this.isInsurance)
      this.cityName = ''
      this.cityOptions = []
    },
    filterVisitTypes(visitTypes) {
      if (!Array.isArray(visitTypes)) return []
      return visitTypes.filter(visit => {
        const name = (visit.name || '').toString().toLowerCase()
        if (this.isInsurance) {
          return name.includes('insurance') || name === 'all' || name === 'todos'
        }
        return !name.includes('insurance')
      })
    },
    async loadOptions() {
      const visitsApi = this.isInsurance ? insuranceVisitsApi : normalVisitsApi
      try {
        const { data } = await visitsApi.visitList(20)
        this.visitTypeOptions = this.filterVisitTypes(data)
      } catch {
        this.visitTypeOptions = []
      }

      const patientApi = getClinicPatientApi(this.programContext)
      try {
        const { data } = await patientApi.referencePagination(10, 1)
        this.referenceOptions = data?.data || data || []
      } catch {
        this.referenceOptions = []
      }

      if (this.isInsurance) {
        try {
          const data = await insuranceNameApi.visitList(20)
          this.insuranceNameOptions = data || []
        } catch {
          this.insuranceNameOptions = []
        }
        try {
          const response = await patientApi.getInsuranceAgents()
          let rawAgents = []
          if (Array.isArray(response?.data?.data)) rawAgents = response.data.data
          else if (Array.isArray(response?.data)) rawAgents = response.data
          else if (Array.isArray(response)) rawAgents = response
          this.agentOptions = rawAgents.map(agent => ({
            id: agent.id,
            name: agent.name || agent.full_name || `Agent #${agent.id}`,
          }))
        } catch {
          this.agentOptions = []
        }
      }
    },
    searchCities() {
      if (!this.cityName) {
        this.cityOptions = []
        return
      }
      clearTimeout(this.citySearchTimer)
      this.citySearchTimer = setTimeout(async () => {
        try {
          const citiesApi = getClinicCitiesApi(this.programContext)
          const response = await citiesApi.citiesFilterFilters({ name: this.cityName })
          const list = Array.isArray(response) ? response : response?.data || []
          this.cityOptions = (list || []).map(city => ({ text: city.name, value: city.id }))
        } catch {
          this.cityOptions = []
        }
      }, 350)
    },
    selectCity(opt) {
      this.form.cities_id = opt.value
      this.cityName = opt.text
      this.cityOptions = []
    },
    buildPayload() {
      const { reason_visit_other, ...rest } = this.form
      let reason_visit = this.form.reason_visit
      if (reason_visit === 'Other' && reason_visit_other) {
        reason_visit = reason_visit_other
      }
      const phone = String(this.form.phone || '').replace(/[() -]/g, '')
      return {
        ...rest,
        phone,
        reason_visit,
        type_membership: 'NP',
      }
    },
    async submit() {
      if (this.cityName && !this.form.cities_id) {
        this.$emit('error', 'Select a city from the list.')
        return
      }
      this.saving = true
      try {
        const api = getClinicPatientApi(this.programContext)
        const payload = this.buildPayload()
        const response = await api.patientCreate(payload)

        const { type, message } = notificationCheck(response)
        const patientId = extractCreatedPatientId(response)

        if (type === 'danger' || type === 'warning') {
          this.$emit('error', message || 'Could not create clinic patient')
          return
        }

        if (!patientId) {
          this.$emit(
            'error',
            'Patient created but ID was not returned. Check console for response shape.'
          )
          return
        }

        const patient = {
          id: patientId,
          name: this.form.name,
          lastname: this.form.lastname,
          email: this.form.email,
          phone: payload.phone,
          date_birth: this.form.date_birth,
        }

        this.$emit('created', { patientId, patient, message })
        this.resetForm()
      } catch (error) {
        const { message } = notificationCheck(error?.response)
        this.$emit('error', message || 'Could not create clinic patient')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.wl-clinic-create-panel {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.city-options-list {
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  max-height: 140px;
  overflow-y: auto;
  margin-top: 0.25rem;
}

.city-option-item {
  padding: 0.45rem 0.75rem;
  cursor: pointer;
}

.city-option-item:hover {
  background: #f3f6f9;
}

::v-deep .wl-clinic-create-panel .vue-treeselect__control,
::v-deep .wl-clinic-create-panel .form-control {
  min-height: 38px;
}
</style>
